var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordHideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8148 10.4477C17.7455 10.3414 16.7172 8.80884 14.8574 7.59008L17.7203 4.73817L16.7006 3.72266L2.65967 17.7071L3.67933 18.7227L7.39023 15.0269C8.17841 15.2718 9.04736 15.4248 9.99924 15.4248C14.9058 15.4248 17.6914 11.4137 17.8075 11.242C17.9704 11.0038 17.9726 10.6893 17.8148 10.4477ZM9.99852 13.9884C9.49951 13.9884 9.02861 13.9324 8.57936 13.8419L9.95454 12.4723C10.1363 12.5219 10.3259 12.552 10.5242 12.552C11.7184 12.552 12.6876 11.5882 12.6876 10.3975C12.6876 10.2007 12.6573 10.0111 12.6075 9.8301L13.8053 8.63719C15.0255 9.37836 15.8814 10.3077 16.3033 10.8291C15.5194 11.7555 13.2876 13.9884 9.99852 13.9884Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67393 13.669L5.72172 12.6255C4.7547 11.9813 4.06098 11.2617 3.69393 10.8279C4.46553 9.86841 6.68947 7.52426 9.99941 7.52426C10.272 7.52426 10.5345 7.54509 10.7919 7.57597L12.0294 6.34356C11.3991 6.18628 10.7256 6.08789 9.99941 6.08789C5.08425 6.08789 2.29928 10.2692 2.1839 10.4473C2.02637 10.6891 2.02898 11.0033 2.19183 11.2416C2.25385 11.3342 3.11342 12.5666 4.67393 13.669Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHideIcon);
export default __webpack_public_path__ + "static/media/passwordHideIcon.17026c005e1fd77e233d9bfe6a661010.svg";
export { ForwardRef as ReactComponent };